import { render, staticRenderFns } from "./carouselRankList.vue?vue&type=template&id=204fca64&scoped=true&"
import script from "./carouselRankList.vue?vue&type=script&lang=js&"
export * from "./carouselRankList.vue?vue&type=script&lang=js&"
import style0 from "./carouselRankList.vue?vue&type=style&index=0&id=204fca64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204fca64",
  null
  
)

export default component.exports